<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-claims-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupClaimsContainerView: () => import('@/components/hris/setup/claims/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Claim',        
      }
    },
  }
</script>
